import ProfilesService from 'top20common/distribution/services/profiles';
import commonUtils from 'top20common/distribution/utils';

export default {
    getApplicationsAction(context) {
        context.commit('mutateApplicationsLoadingState', true);
        return context.dispatch('getApplicationsInBackgroundAction');
    },
    getApplicationsInBackgroundAction(context) {
        return new Promise((resolve, reject) => {
            ProfilesService.getApplications()
                .then(response => {
                    context.commit('setApplicationsListState', response.data.results);
                    context.commit('setApplicationsMetaState', response.data.meta);
                    context.commit('mutateApplicationsErrorState', null);
                    resolve(response.data.results);
                })
                .catch(error => {
                    context.commit('mutateApplicationsErrorState', commonUtils.getErrorMessageFromResponse(error.response));
                })
                .finally(function () {
                    context.commit('mutateApplicationsLoadingState', false);
                });
        });
    },
    createJobApplicationAction(context, {code, query = {}}) {
        context.commit('mutateCreateApplicationLoadingState', true);
        return new Promise((resolve, reject) => {
            ProfilesService.createJobApplication({code: code, query: query})
                .then(response => {
                    context.commit('mutateAddApplicationToListState', response.data);
                    context.commit('mutateCreateApplicationLoadingState', false);
                    resolve(response.data);
                })
                .catch(error => {
                    context.commit('mutateCreateApplicationLoadingState', false);
                    if (error.response.status === 400) {
                        reject(commonUtils.getErrorMessageFromResponse(error.response));
                    }
                });
        });
    },
    createPreApplicationAction(context, {code, email, phone, resume_file}) {
        context.commit('mutateCreatePreApplicationLoadingState', true);
        let formData = new FormData();
        if(resume_file) {
          formData.append('resume_file', resume_file[0]);
        }
        formData.append('code', code);
        formData.append('email', email || '');
        formData.append('phone', phone || '');
       
        return new Promise((resolve, reject) => {
            ProfilesService.createPreApplication(formData)
                .then(response => {
                    context.commit('mutateCreatePreApplicationLoadingState', false);
                    resolve(response.data);
                })
                .catch(error => {
                    context.commit('mutateCreatePreApplicationLoadingState', false);
                    if (error.response.status === 400) {
                        reject(commonUtils.getErrorMessageFromResponse(error.response));
                    }
                });
        });
    },
    createJobApplicationForRecommendedJobActionByTime(context, {recommendedJobId, code, query = {}, dismissTime = 600}) {
        context.commit('mutateRecommendedJob', {id: recommendedJobId, payload: {isHidden: true}});

        const startRequestTime = new Date().getTime();
        return new Promise((resolve, reject) => {
            ProfilesService.createJobApplication({code: code, query: query})
                .then(response => {
                    const endRequestTime = new Date().getTime();
                    let timeOfRequest = endRequestTime - startRequestTime;
                    setTimeout(() => {
                        context.commit('mutateAddApplicationToListState', response.data);
                    }, timeOfRequest < dismissTime ? dismissTime - timeOfRequest : 0);

                    resolve(response.data);
                })
                .catch(error => {
                    context.commit('mutateRecommendedJob', {id: recommendedJobId, payload: {isHidden: false}});

                    if (error.response.status === 400) {
                        reject(commonUtils.getErrorMessageFromResponse(error.response));
                    }
                });
        });
    }
};
